/* eslint-disable no-return-assign */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-tabs */
import { Flex, Text, Box, FormControl, FormLabel, Select, Input, InputRightElement, InputGroup, useToast, Tabs, TabList, Tab, TabPanels, TabPanel } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BoxAzul, OutlineListaContainer } from '../styles'
import { FaComments, FaFilter, FaSearch } from 'react-icons/fa'
import { FeedbackChart } from '../Components/PieChart'
import { CsvButton } from '../../../../../components/Buttons/CsvButton'
import { ModalDelete } from '../../../../../components/ModalDelete'
import { WhiteBox } from '../../../../../components/WhiteBox'
import { appApi, urlApi } from '../../../../../services/appApi'
import { ObterToken } from '../../../../../Utils/Helper'
import { Body } from '../../../../Layouts/Body'
import { Button } from '../../../../../components/Button'
import { parseJwt } from '../../../../../services/token'
import { DashboardSwitch } from '../../../../../components/DashboardSwitch'
import { TableFeedback } from '../Components/TableFeedback'
import { iAvatarXInformacoes } from '../../../../../interfaces'
import { iLinhaGeral, TableColaboradores } from '../Components/TableColaboradores'
import { Paginador } from '../../../../../components/Paginador'

interface iModel {
  tabela: iLinhaTabela[]
  quantidade?: number
  quantidadePorColaborador?: number
  tabelaPorColaborador: iLinhaGeral[]
}

export interface iLinhaTabela {
  id: string
  criador: iAvatarXInformacoes
  convidado: iAvatarXInformacoes
  nome: string
  dataInicio: string
  comentarios: number
  status: number
}

interface iFiltro {
  search: string
  dataInicio: string
  dataFim: string
  status: string
}

export const DashboardCorporativoFeedback: React.FC = () => {
  const toast = useToast()
  const nav = useNavigate()
  const { pathname } = useLocation()
  const [Model, setModel] = useState<iModel>({ tabela: [], tabelaPorColaborador: [] })
  const [ModelSemFiltros, setModelSemFiltros] = useState<iModel>({ tabela: [], tabelaPorColaborador: [] })

  const [Filtro, setFiltro] = useState<iFiltro>({
    dataFim: '',
    dataInicio: '',
    search: '',
    status: ''
  })
  const [IsLoading, setIsLoading] = useState(false)
  const [Ordenador, setOrdenador] = useState({ filtro: 1, ascendente: true })
  const [Pagina, setPagina] = useState(0)
  const [Tamanho, setTamanho] = useState(25)

  const [Id, setId] = useState<string>()
  const [DeletarIsOpen, setDeletarIsOpen] = useState(false)

  const [ViewColaborador, setViewColaborador] = useState(true)

  function Carregar(): void {
    setIsLoading(true)
    appApi.get(`Feedback/Dashboard/Corporativo/?busca=${Filtro.search}&dataFim=${Filtro.dataFim}&dataInicio=${Filtro.dataInicio}&status=${Filtro.status}&tamanho=${Tamanho}&pagina=${Pagina}&ordenador=${Ordenador.filtro}&ascendente=${Ordenador.ascendente}`)
      .then(res => {
        if ((res.data?.tabela?.length > 0 || res.data?.tabelaPorColaborador?.length > 0) || Pagina === 0) {
          setModel(res.data)
        } else {
          setPagina(0)
        }
        setIsLoading(false)
      })
      .catch(err => {
        console.log(err)
        setIsLoading(false)
      })
  }

  function CarregarSemFiltros(): void {
    setIsLoading(true)
    appApi.get('Feedback/Dashboard/Corporativo/?busca=&dataFim=&dataInicio=&status=')
      .then(res => {
        if (res.status === 200) {
          setModelSemFiltros(res.data)
        } else {
          setModelSemFiltros({ tabela: [], tabelaPorColaborador: [] })
        }
        setIsLoading(false)
      })
      .catch(err => console.log(err))
  }

  function ReenviarConvite(id: string): void {
    appApi.post(`Feedback/${id}/ReenviarConvite`)
      .then(() => toast({
        title: 'Convite reenviado com sucesso!',
        status: 'success',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      }))
      .catch(err => console.log(err))
  }

  function Deletar(): void {
    appApi.delete(`Feedback/${Id ?? ''}`)
      .then(() => {
        toast({
          title: 'Feedback excluido com sucesso!',
          status: 'success',
          isClosable: false,
          position: 'top-right',
          duration: 4000
        })
        setModel({ ...Model, tabela: [...Model?.tabela.filter(e => e.id !== Id)] })
      })
      .catch(err => console.log(err))
  }

  function onOpenDelete(id: string): void {
    setDeletarIsOpen(true)
    setId(id)
  }

  function onCloseDelete(): void {
    setDeletarIsOpen(false)
    setId(undefined)
  }

  useEffect(() => {
    CarregarSemFiltros()
  }, [])

  useEffect(() => {
    Carregar()
  }, [Pagina, Tamanho, Ordenador])

  return (
    <Body isLoading={IsLoading}>
      {DeletarIsOpen &&
        <ModalDelete
          isOpen
          onConfirm={Deletar}
          onRequestClose={onCloseDelete}
          message='Deseja realmente excluir esse feedback?'
        />
      }

      <WhiteBox>
        <Flex mb={'1rem'} justifyContent={'space-between'}>
          <h1>Feedback</h1>
          <Button
            onClick={() => nav(`${pathname.replace('Feedback/Dashboard/Corporativo', 'NovaReuniaoOne/Criar')}`)}
            VarColor='Green2'
            size={'lg'}
          >Solicitar reunião 1:1</Button>
        </Flex>
        {(parseJwt().adm === 'True' || parseJwt().role === '2') &&
          <DashboardSwitch />
        }
        <Flex justifyContent={'space-between'} mt='1rem' maxH={'10rem'} gap={'1rem'}>
          <BoxAzul>
            <Flex alignItems={'center'} justifyContent={'center'} gap={'1rem'} px={'2rem'}>
              <FaComments size={40} style={{ color: 'white' }} />
              <Box>
                <Text fontSize={'28px'} fontWeight={'700'}>{Model?.quantidade}</Text>
                <Text fontSize={'20px'} fontWeight={'400'} mt={'-5px'}>Feedbacks</Text>
              </Box>
            </Flex>
          </BoxAzul>
          <Box borderRadius={'1rem'} border={'1px solid var(--Azul)'} w={'100%'}>
            <Flex alignItems={'center'} borderRadius={'1rem'} justifyContent={'center'} gap={'1rem'} backgroundColor={'#fff'} padding={'1rem'} overflow={'hidden'}>
              {!IsLoading && <FeedbackChart
                model={ModelSemFiltros?.tabela}
                variant='corporativo'
              />}
            </Flex>
          </Box>
        </Flex>
        <Flex gap={'2rem'} alignItems={'flex-end'} mt={'1rem'}>
          <FormControl>
            <FormLabel>Status</FormLabel>
            <Select onChange={(e) => setFiltro({ ...Filtro, status: e.target.value })}>
              <option value="">Todos</option>
              <option value="2">Aguardando inicio</option>
              <option value="3">Pendentes por colaborador</option>
              <option value="4">Pendentes por gestor</option>
              <option value="5">Finalizadas</option>
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel>Periodo</FormLabel>
            <Flex alignItems={'center'} gap={'1rem'}>
              De: <Input onChange={(e) => setFiltro({ ...Filtro, dataInicio: e.target.value })} type={'date'} max={'2099-12-31T23:59'} />
              Até: <Input onChange={(e) => setFiltro({ ...Filtro, dataFim: e.target.value })} type={'date'} max={'2099-12-31T23:59'}/>
            </Flex>
          </FormControl>
          <Flex minW={'23rem'} gap={'.75rem'} justifyContent={'end'}>
            <InputGroup width={'100%'}>
              <Input
                borderColor={'var(--Gray4)'}
                type='text'
                placeholder='Pesquisa'
                onChange={(e) => setFiltro({ ...Filtro, search: e.target.value })}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    Carregar()
                  }
                }}
              />
              <InputRightElement
                pointerEvents='none'
                children={<FaSearch color='var(--Gray4)' />}
              />
            </InputGroup>

            <Flex justifyContent='end' alignItems='center'>
              <Button VarColor='a1' rightIcon={<FaFilter />} onClick={() => { Carregar() }}>Filtrar</Button>
            </Flex>
          </Flex>
        </Flex>
        <OutlineListaContainer>
          <Flex justifyContent={'space-between'}>
            <Text fontWeight={'700'} fontSize={'24px'}>Listas de feedbacks</Text>
            {parseJwt().adm === 'True' &&
              <CsvButton
                onClick={() => window.location.href = `${urlApi}/Feedback/Csv/${ViewColaborador ? 'Gestor' : 'Colaborador'}?token=${ObterToken()}`}
              />
            }
          </Flex>
          <Tabs colorScheme={'blue'} variant='enclosed-colored' mt={'1rem'}>
            <TabList w={'80%'}>
              <Tab
                bgColor={'#fff'}
                borderRadius={'8px 8px 0 0'}
                _selected={{ color: 'var(--Azul)', fontWeight: '700' }}
                color='var(--Gray2)'
                onClick={() => { setViewColaborador(true); setPagina(0); setOrdenador({ ...Ordenador, filtro: 0 }) }}
              >Lista por colaboradores</Tab>

              <Tab
                bgColor={'#fff'}
                borderRadius={'8px 8px 0 0'}
                _selected={{ color: 'var(--Azul)', fontWeight: '700' }}
                color='var(--Gray2)'
                onClick={() => { setViewColaborador(false); setPagina(0); setOrdenador({ ...Ordenador, filtro: 0 }) }}
              >Lista por feedback</Tab>
            </TabList>
            <TabPanels>
              <TabPanel p={'0'}>
                <Paginador
                  next={(e) => setPagina(e)}
                  prev={(e) => setPagina(e)}
                  tamanho={Tamanho}
                  setTamanho={(e) => setTamanho(e)}
                  paginaAtual={Pagina}
                  qtdElementos={Model?.quantidadePorColaborador ?? 0}
                  hideTop={true}
                >
                  <TableColaboradores
                    tabela={Model?.tabelaPorColaborador}
                    onOrdenar={(filtro, ascendente) => setOrdenador({ ascendente: ascendente, filtro: filtro })}
                  />
                </Paginador>
              </TabPanel>
              <TabPanel p={'0'}>
                <Paginador
                  next={(e) => setPagina(e)}
                  prev={(e) => setPagina(e)}
                  tamanho={Tamanho}
                  setTamanho={(e) => setTamanho(e)}
                  paginaAtual={Pagina}
                  qtdElementos={Model?.quantidade ?? 0}
                  hideTop={true}
                >
                  <TableFeedback
                    onReenviar={ReenviarConvite}
                    onExcluir={onOpenDelete}
                    onOrdenar={(filtro, ascendente) => setOrdenador({ ascendente: ascendente, filtro: filtro })}
                    feedbacks={Model?.tabela}
                  />
                </Paginador>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </OutlineListaContainer>
      </WhiteBox>
    </Body>
  )
}
